<template>
  <div class="row center">
    <!--
    <div class="col-4 jewelry-type-bg">
      <h1>Select Jewelry Type</h1>
      <h3>Start by choosing the jewelry types you wish to go with.</h3>
    </div>
    -->
    <div class="col-12 selectjewelry center">
      <el-form :model="model" :rules="rules" ref="form">
        <el-form-item prop="category">
          <input type="hidden" v-model="model.category" value=""/>

            <div :class="rootClass">
              <ul :class="`${rootClass}__wrapper`">
                <li v-for="(dataImage, index) in dataImages" :key="index" :class="`${rootClass}__item`">
                  <div :id="`c${dataImage.id}`"
                    :class="classThumbnailMultiple(dataImage.id, dataImage.alt, dataImage.disabled)"
                    @click="onSelectMultipleImage(dataImage)"
                  >
                    <img
                      :src="dataImage.src"
                      :alt="dataImage.alt"
                      :id="dataImage.id"
                      :height="h"
                      :width="w"
                      :class="`${rootClass}__img`"
                    />                   
                    <label :for="dataImage.id" :class="`${rootClass}__lbl`">{{dataImage.alt}}</label>
                  </div>
                </li>
              </ul>
            </div>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// add stylesheet
require('vue-select-image/dist/vue-select-image.css')

import RingsType from '../../../../public/assets/front/images/findjewelry/ring.svg'
import BraceletType from '../../../../public/assets/front/images/findjewelry/bracelet.svg'
import NecklaceType from '../../../../public/assets/front/images/findjewelry/necklace.svg'
import EarringsType from '../../../../public/assets/front/images/findjewelry/earring.svg'
import PendantType from '../../../../public/assets/front/images/findjewelry/pendant.svg'
const params = new URLSearchParams(window.location.search)

export default {
  data(){
	return {
    rootClass: "vue-select-image",
    activeClass: "vue-select-image__thumbnail--selected",    
    h: '125px',
    w: '125px',
    multipleSelected: [],
    limit: 0,
    apistates_url: window.apistates_url,
    categories:[],
    //dataImages: this.categoriesdata,
    dataImages: [
      { id: '7', src: RingsType, alt: 'Rings', disabled: true}, 
      { id: '8', src: EarringsType, alt: 'Earrings', disabled: true},
      { id: '9', src: BraceletType, alt: 'Bracelet', disabled: true}, 
      { id: '10', src: NecklaceType, alt: 'Necklace', disabled: true},
      { id: '11', src: PendantType, alt: 'Pendant', disabled: true}
    ],
    model: {
      category: '',
    },
    rules: {
      category: [{
        required: true,
        message: 'Please select at least one jewelry category.',
        trigger: 'change'
      }],
    }
	}},
  props: [
    'categoriesdata',
  ],
  created() {
    this.URLparams();
  },
  methods: {
    URLparams() {
      const baseClass = `${this.rootClass}__thumbnail`;
      const activeClass = `${this.activeClass}`;
      var paraCats = ''

      if ( params.has('productCats') ) paraCats =  params.getAll('productCats').toString()
      if ( params.has('category') ) paraCats =  params.getAll('category').toString()

      this.model.category = ( ( params.has('productCats') || params.has('category') )  	? paraCats : '')

      // this.model.category to associative array 'id' same as in this this.multipleSelected
      var arr_category = {}
        this.model.category.split(',').forEach(element => {
          arr_category = { 'id' : parseInt(element)}
      })
      this.multipleSelected = [].concat([ arr_category ]);

      var parsedobj = this.model.category.split(',')
      document.addEventListener("DOMContentLoaded", function() {
        parsedobj.forEach(element => {
          var typeClasses = `#c${element}` 
          var selection = document.querySelector(typeClasses) !== null;
          if ( selection )
            document.querySelector(typeClasses).classList.add("vue-select-image__thumbnail--selected") 
        });
      })
      return this.model
    },
    assignAssetSrc: function ( src ) {
      switch ( src ) {
        case 'RingsType': return RingsType; break;
        case 'EarringsType': return EarringsType; break;
        case 'NecklaceType': return NecklaceType; break;
        case 'BraceletType': return BraceletType; break;
        case 'PendantType': return PendantType; break;
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          this.$emit('on-validate', valid, this.model)
          resolve(valid);
        });
      })
    },
    onChange() {
      this.$emit("can-continue", { value: true });
    },
    classThumbnailMultiple(id, alt, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      const baseMultipleClass = `_${alt.toLowerCase()} ${baseClass} is--multiple`;
      
			var typeClasses = `._${alt.toLowerCase()}` 
			var selection = document.querySelector(typeClasses) !== null;
      
      if (isDisabled) {
        if (selection) {
          if (document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`) ) {
            return `${baseMultipleClass} ${baseClass}--disabled`;
          }
        }          
      }
      if (this.isExistInArray(id) && !isDisabled) {
        if (selection) {
          if (!document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`) ) {
            return `${baseMultipleClass} ${this.activeClass}`;
          }
        }          
      }
      return `${baseMultipleClass}`;
    },
    isExistInArray(id) {
      return this.multipleSelected.find(item => {
        return id === item.id;
      });
    },
    removeFromMultipleSelected(id, dontFireEmit) {
      this.multipleSelected = this.multipleSelected.filter(item => {
        return id !== item.id;
      });
      if (!dontFireEmit) {
        this.$emit("onselectmultipleimage", this.multipleSelected);
      }
    },
    resetMultipleSelection() {
      this.multipleSelected = [];
    },
    onSelectMultipleImage(objectImage) {
      const baseClass = `${this.rootClass}__thumbnail`;
      const baseMultipleClass = `_${(objectImage.alt).toLowerCase()} ${baseClass} is--multiple`;

      var typeClasses = `._${(objectImage.alt).toLowerCase()}`
      //console.log(typeClasses)
      if (!document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`)) {
        objectImage.disabled = false
      } 

      if (!objectImage.disabled) {
        if (!this.isExistInArray(objectImage.id)) {
          if (this.limit > 0) {
            if (this.multipleSelected.length < this.limit) {
              this.multipleSelected.push(objectImage);
              this.$emit("onselectmultipleimage", this.multipleSelected);
            } else {
              this.$emit("onreachlimit", this.limit);
            }
          } else {
            this.multipleSelected.push(objectImage);
            this.$emit("onselectmultipleimage", this.multipleSelected);
          }
        } else {
          this.removeFromMultipleSelected(objectImage.id, true);
          this.$emit("onselectmultipleimage", this.multipleSelected);
        }
      } else {
        //console.log(objectImage.stoneclass + ' has jewelry-disabled and cannot be selected.' )
      }      

      this.categories = [];
      var parsedobj = JSON.parse(JSON.stringify(this.multipleSelected))
      parsedobj.forEach(element => {
        if (!document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`)) {
          this.categories.push(element.id)
        }         
      });

      //removes extra prefix ","
      this.categories = this.categories.filter(function( element ) {
        //return element !== undefined;
        return element !== null && element !== undefined;
      }); 

      this.model.category = JSON.parse(JSON.stringify(this.categories)).join(',')
    },    
    async fetchDataImages() {
      const url = '/api/client/products_categories';
      const headers = {
          "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
          "clientid": "1234",
          "clientsecret": "sk_1234",
          }
      const response = await axios.get(url, {headers})
      const results = response.data
      this.dataImages = results.map(item => ({
          id: item.id,
          src: this.assignAssetSrc(item.src),
          alt: item.alt,
          disabled: (item.disabled > 0 ? false : true)
      }))
    }
  },
  mounted() {
    this.fetchDataImages()
  },
}
</script>

<style lang="scss" scoped>
	.vue-select-image__item {
		display: inline-block;
		padding: 5px 5px 3px 5px;
		margin: 5px;
		min-width: 35px;
		min-height: 35px;
		line-height: 37px;
		color: #333;
		text-decoration: none;
		text-align: center;
		background-color: #fff;
    float:none;
	}
</style>